import React, { useContext, useState } from 'react';
import './topbar.css';
import UserAvatar from './changeAvatar/userAvatar';
import { Link, Route } from 'react-router-dom';
import Notification from './notification/notification';
import Account from './account/account';
import { Context } from '../../services/context';
import {
  Button,
  Dropdown,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Container,
} from 'react-bootstrap';
import Fontawesome from '../fontawesome/fontawesome';
import { useLocation } from 'react-router-dom';
import { AiOutlineSound } from "react-icons/ai";
import { RxSpeakerOff } from "react-icons/rx";
import { TbAlertTriangle, TbAlertTriangleOff } from "react-icons/tb";

const Topbar = () => {
  const ctx = useContext(Context);
  const [enableAlert, setEnableAlert] = useState(() => {
    const savedAlert = localStorage.getItem("@enableAlert");
    return savedAlert ? savedAlert === "on" : false;
  });
  
  const [enableSound, setEnableSound] = useState(() => {
    const savedSound = localStorage.getItem("@enableSound");
    return savedSound ? savedSound === "on" : false;
  });
  
  const toggleAlert = () => {
    const newAlertState = !enableAlert;
    setEnableAlert(newAlertState);
    localStorage.setItem("@enableAlert", newAlertState ? "on" : "off");
  };
  
  const toggleSound = () => {
    const newSoundState = !enableSound;
    setEnableSound(newSoundState);
    localStorage.setItem("@enableSound", newSoundState ? "on" : "off");
  };
  
  const linkManual = (e) => {
    window.open('https://manual.dtlab.com.br/', '_blank');
    document.location.reload(true);
  };

  const idUser = localStorage.getItem('@fn_mtechsp');

  const handleToggle = () => {
    ctx.setIsActiveToggle(ctx.isActiveToggle === true ? false : true);
  };

  let location = useLocation();
  const nameUser = localStorage.getItem('@user_mtechsp').replace(/[\\"]/g, '');

  return (
    <Container fluid className="topbar sticky-top" style={{zIndex: 999}}>
      <Row>
        <Col
          md="12"
          className="d-flex align-items-center justify-content-between"
        >
          <div>
            <Button
              variant="primary"
              onClick={handleToggle}
              style={{
                color: '#585858',
                backgroundColor: '#63191a00',
                border: '0',
                fontSize: '20px',
              }}
            >
              <Fontawesome classe="fa fa-bars" />
            </Button>
          </div>
          <div style={{ display: 'flex' }}>
            {location.pathname == '/gestao/inicio' ? (
              <></>
            ) : (
              // <Dropdown className="ml-4 dropdown-dashboard">
              //   <Dropdown.Toggle variant="secondary" id="dropdown-basic">
              //     <Fontawesome classe="fas fa-chart-line mr-3" /> Visualização
              //   </Dropdown.Toggle>

              //   <Dropdown.Menu>
              //     <Dropdown.Item href="#" onClick={() => ctx.setDashboard(1)}>
              //       Mapa Geral
              //     </Dropdown.Item>
              //     {/* <Dropdown.Item href="#" onClick={() => ctx.setDashboard(2)}>
              //       Monitoramento
              //     </Dropdown.Item> */}
              //     <Dropdown.Item href="#" onClick={() => ctx.setDashboard(3)}>
              //       Gráficos
              //     </Dropdown.Item>
              //   </Dropdown.Menu>
              // </Dropdown>
              ''
            )}

            {
              location.pathname == '/monitoramento/inicio' &&
              (
                <div className='d-flex'>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="button-tooltip-2">Habilitar notificação de alertas</Tooltip>
                    }
                  >
                    <div className='btn-topbar' onClick={toggleAlert}>
                      {enableAlert ? <TbAlertTriangle color='#7C2525' size={20} /> : <TbAlertTriangleOff color='#7C2525' size={18} />}
                    </div>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="button-tooltip-2">Habilitar som de alertas</Tooltip>
                    }
                  >
                    <div className='btn-topbar' onClick={toggleSound}>
                      {enableSound ? <AiOutlineSound color='#7C2525' size={20} /> : <RxSpeakerOff color='#7C2525' size={18} />}
                    </div>
                  </OverlayTrigger>
                </div>
              )
            }

            <div className="dropdown">
              <div className="btn-topbar">
                <Route>
                  <a
                    onClick={linkManual}
                    className="dropdown"
                    id="dropdownNotification"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="button-tooltip-2">Manual DTLab</Tooltip>
                      }
                    >
                      <svg
                        id="manual"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9 2.06268C12.8318 2.06268 15.9375 5.16918 15.9375 9.00018C15.9375 12.8312 12.8318 15.9377 9 15.9377C5.169 15.9377 2.0625 12.8312 2.0625 9.00018C2.0625 5.16918 5.169 2.06268 9 2.06268Z"
                          stroke="#741717"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8.99634 6.15326V9.46751"
                          stroke="#741717"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8.99625 11.8471H9.00375"
                          stroke="#741717"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </OverlayTrigger>
                  </a>
                </Route>
                <div
                  className="dropdown-menu fade-in-top"
                  aria-labelledby="dropdownNotification"
                ></div>
              </div>
            </div>

            <div className="dropdown">
              <div className="btn-topbar">
                <Link
                  to="#"
                  className="dropdown"
                  id="dropdownNotification"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="button-tooltip-2">Notificações</Tooltip>
                    }
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.0361 2H11.9648C8.59565 2 5.50654 4.44456 5.20685 7.68096C5.18686 7.91248 5.17324 8.14906 5.16444 8.40391L5.15213 8.99974L5.14969 9.53395L5.16473 9.47306C5.02569 10.151 4.70525 10.7799 4.23653 11.2938L4.16936 11.3802C3.76804 11.9898 3.53744 12.6955 3.50175 13.4242L3.5009 13.6624C3.48041 14.6208 3.80882 15.5691 4.42663 16.3223C5.26444 17.2069 6.34896 17.7346 7.51296 17.8466C10.49 18.1699 13.502 18.1699 16.4873 17.8457C17.6434 17.7393 18.7311 17.2101 19.5338 16.3582C20.1399 15.6331 20.4707 14.763 20.499 13.862L20.5 13.4587C20.4668 12.698 20.2348 11.9917 19.8286 11.3847L19.7669 11.3055L19.6162 11.1282C19.2776 10.7052 19.0303 10.218 18.8896 9.69688L18.845 9.50977L18.8358 9.31353C18.833 9.22527 18.8317 9.1274 18.8312 9.00516L18.8311 8.33206C18.8288 8.07458 18.8212 7.89148 18.8034 7.68536C18.4934 4.44285 15.4034 2 12.0361 2ZM11.9648 3.39535H12.0361C14.7336 3.39535 17.1944 5.34075 17.4307 7.81326C17.4447 7.97558 17.4509 8.13044 17.4528 8.3605L17.4555 9.26514C17.4585 9.40982 17.4642 9.53013 17.4739 9.66551L17.4868 9.75818L17.5517 10.034C17.744 10.7635 18.0893 11.4441 18.5647 12.0309L18.7026 12.1926L18.6873 12.1672C18.951 12.5613 19.1013 13.0186 19.1223 13.4901L19.1216 13.6536C19.1375 14.3097 18.9199 14.933 18.5084 15.4267C17.9645 16.002 17.1871 16.3802 16.3514 16.4572C13.4527 16.7719 10.5393 16.7719 7.65168 16.4583C6.80682 16.377 6.02881 15.9985 5.45369 15.3931C5.08086 14.9356 4.86568 14.3142 4.87919 13.6774L4.87935 13.4587L4.89682 13.2682C4.9389 12.9495 5.04539 12.6265 5.21045 12.3291L5.29415 12.1905C5.90779 11.5004 6.32892 10.6611 6.51441 9.75667L6.52879 9.61486L6.53532 8.69559L6.55137 8.2292C6.55866 8.08207 6.56798 7.94228 6.57967 7.80678C6.80804 5.34087 9.26651 3.39535 11.9648 3.39535ZM5.29415 12.1905C5.27931 12.2072 5.26436 12.2238 5.24929 12.2404L5.29856 12.1833L5.29415 12.1905ZM14.608 19.6906C14.3114 19.4491 13.8775 19.4967 13.6389 19.7969C13.5355 19.927 13.4158 20.0437 13.2826 20.1443C12.8307 20.4986 12.2669 20.6564 11.7064 20.5896C11.1467 20.523 10.6379 20.2381 10.2927 19.7995C10.0555 19.4981 9.62189 19.4484 9.32417 19.6885C9.02646 19.9286 8.9774 20.3676 9.21459 20.6689C9.787 21.3962 10.6258 21.8659 11.5453 21.9754C12.464 22.0849 13.3891 21.826 14.1167 21.255C14.3327 21.0922 14.5366 20.8935 14.7129 20.6715C14.9515 20.3713 14.9045 19.9321 14.608 19.6906Z"
                        fill="#780D0D"
                      />
                    </svg>
                  </OverlayTrigger>
                </Link>
                <div
                  className="dropdown-menu fade-in-top"
                  aria-labelledby="dropdownNotification"
                >
                  <Notification />
                </div>
              </div>
            </div>

            <div className="dropdown">
              <div className="btn-topbar">
                <Link
                  to="#"
                  className="dropdown"
                  id="dropdownNotification"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="button-tooltip-2">Minha Conta</Tooltip>
                    }
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.0043 2C9.07027 2 6.69177 4.38864 6.69177 7.33517C6.69177 10.2817 9.07027 12.6703 12.0043 12.6703C14.9383 12.6703 17.3168 10.2817 17.3168 7.33517C17.3168 4.38864 14.9383 2 12.0043 2ZM12.0043 3.44767C14.1422 3.44767 15.8753 5.18816 15.8753 7.33517C15.8753 9.48218 14.1422 11.2227 12.0043 11.2227C9.8664 11.2227 8.1333 9.48218 8.1333 7.33517C8.1333 5.18816 9.8664 3.44767 12.0043 3.44767ZM9.83005 14.8209C9.05233 14.8749 8.26621 14.9859 7.4908 15.1521C5.99418 15.4604 4.79685 16.0763 4.28724 17.0999C4.09503 17.5002 3.99839 17.9288 4.00002 18.3627C3.99944 18.7935 4.0953 19.2227 4.28062 19.6153C4.76994 20.6271 5.8278 21.1997 7.25624 21.5171L7.51213 21.5705C8.26648 21.7407 9.05284 21.8553 9.84446 21.909C9.91189 21.9288 10.0726 21.9472 10.248 21.9561L10.3922 21.9615C10.4664 21.9633 10.5506 21.9637 10.676 21.9637C11.8138 22.0263 12.9934 22.0081 14.1675 21.9081C14.7932 21.8653 15.4231 21.7835 16.0477 21.6636L16.5151 21.5666C18.0576 21.2623 19.2126 20.6836 19.7186 19.6164C20.0937 18.8241 20.0937 17.9047 19.7188 17.1127C19.214 16.0483 18.0737 15.4744 16.5034 15.1509C15.8873 15.0194 15.2612 14.922 14.6307 14.8599L14.1697 14.8209C12.7259 14.6935 11.2738 14.6935 9.83005 14.8209ZM14.0436 16.263L14.0562 16.264C14.7799 16.3149 15.4991 16.4165 16.2087 16.568C17.3751 16.8083 18.1667 17.2067 18.4171 17.7348C18.6057 18.133 18.6057 18.5958 18.4169 18.9944C18.1829 19.4879 17.472 19.8691 16.4445 20.1021L16.2195 20.1498C15.496 20.3112 14.7791 20.4152 14.0576 20.4647C12.9379 20.5599 11.8249 20.5771 10.7148 20.5171L10.3212 20.5103C10.2119 20.5048 10.1198 20.4942 10.0345 20.4771C9.35872 20.4261 8.75066 20.3454 8.16027 20.2283L7.80775 20.1537C6.63771 19.9244 5.83915 19.5243 5.58024 18.989C5.48964 18.797 5.44125 18.5803 5.44154 18.3609C5.44073 18.1428 5.48848 17.931 5.58118 17.7379C5.83293 17.2324 6.67919 16.7971 7.78606 16.569C8.50073 16.4159 9.21962 16.3144 9.94294 16.264C11.316 16.143 12.6837 16.143 14.0436 16.263Z"
                        fill="#780D0D"
                      />
                    </svg>
                  </OverlayTrigger>
                </Link>
                <div
                  className="dropdown-menu fade-in-top"
                  aria-labelledby="dropdownNotification"
                >
                  <Account />
                </div>
              </div>
            </div>

            <div className="btn-topbar">
              <Link to="#" onClick={ctx.handleLogout}>
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="button-tooltip-2">Sair</Tooltip>}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.4936 6.23864C21.3848 3.89119 19.4478 2.02197 17.0734 2.02197H12.1894L11.9806 2.0268C9.62755 2.13576 7.75438 4.07656 7.75438 6.45597V7.38897L7.76123 7.49074C7.81089 7.85682 8.12469 8.13897 8.50438 8.13897C8.9186 8.13897 9.25438 7.80319 9.25438 7.38897V6.45597L9.25936 6.28353C9.34859 4.74295 10.6256 3.52197 12.1894 3.52197H17.0734L17.2453 3.52694C18.781 3.61588 19.9984 4.88889 19.9984 6.44697V17.587L19.9934 17.7594C19.9041 19.3 18.6263 20.522 17.0634 20.522H12.1784L12.0066 20.517C10.472 20.428 9.25438 19.1543 9.25438 17.597V16.655L9.24754 16.5532C9.19788 16.1871 8.88408 15.905 8.50438 15.905C8.09017 15.905 7.75438 16.2408 7.75438 16.655V17.597L7.75949 17.8113C7.87131 20.1552 9.80715 22.022 12.1784 22.022H17.0634L17.2721 22.0171C19.6245 21.9081 21.4984 19.9662 21.4984 17.587V6.44697L21.4936 6.23864ZM12.3534 8.57653C12.6191 8.30972 13.0357 8.28466 13.3298 8.50191L13.414 8.57435L16.342 11.4904C16.6096 11.7568 16.6339 12.1749 16.415 12.469L16.4123 12.4721C16.3914 12.4999 16.3685 12.5263 16.344 12.5509L16.342 12.5532L13.414 15.4692C13.1205 15.7615 12.6457 15.7605 12.3534 15.467C12.0876 15.2002 12.0643 14.7835 12.2828 14.4903L12.3555 14.4064L13.9963 12.7718H3.77148C3.35727 12.7718 3.02148 12.436 3.02148 12.0218C3.02148 11.6421 3.30364 11.3283 3.66971 11.2786L3.77148 11.2718H13.9961L12.3555 9.63719C12.0887 9.37147 12.0637 8.95486 12.2809 8.6608L12.3534 8.57653Z"
                      fill="#780D0D"
                    />
                  </svg>
                </OverlayTrigger>
              </Link>
            </div>

            <div className="welcome">
              <span>Olá {nameUser}</span>
              <UserAvatar idUser={idUser} />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default Topbar;
